import { Button } from 'components'
import React from 'react'

import HeroImage from '../assets/hero.svg'

const HeroSection = () => {
  return (
    <section>
      <div className="flex justify-between items-center">
        <div>
          <div className="space-y-3">
            <h1 className="text-2xl font-semibold tracking-wide md:text-4xl">
              Creating Phenomenal
              <br />
              Engineers of <span className="text-green-500">Tomorrow</span>
            </h1>
            <p className="mt-3 max-w-xl text-base text-slate-400 sm:text-xl lg:text-lg xl:text-xl">
              Devsnest School Community helps us choose the right tech college,
              provides you with mentorship and guidance via industry
              professionals from top tech companies
            </p>
            <p className="mt-3 max-w-xl text-base text-slate-400 sm:text-xl lg:text-lg xl:text-xl">
              Join us today to jumpstart your career in technology.
            </p>
          </div>
          <a
            href="https://devsnest.in/r/tech-school"
            target="_blank"
            rel="noreferrer">
            <Button variant={'success'} className="mt-5">
              Join Now
            </Button>
          </a>
        </div>
        <div className="hidden md:block w-[450px] h-[450px]">
          <img className="w-full h-full" src={HeroImage.src} alt="" />
        </div>
      </div>
    </section>
  )
}

export default HeroSection
